import { useEffect } from 'react'
import { usePostAppointmentContext } from '../../context/PostAppointmentContext/PostAppointmentProvider'
import { useSourcePluginContext } from '../../context/SourcePluginContext'
import useAppointments from '../../hooks/useAppointments'
import { Appointment, AppointmentNote } from '../../types/types'
import PostAppointmentNoteTableRow from './PostAppointmentNoteTableRow'

const Initial = () => {
  const { pluginContext } = useSourcePluginContext()
  const {
    updateSelectedNote,
    nextScreen,
    setCurrentScreen,
    updateSelectedAppointment,
    resetValues,
    startEdit,
  } = usePostAppointmentContext()
  const { completedAppointments: appointments } = useAppointments(
    pluginContext?.member ?? undefined
  )

  const createNew = (appointment: Appointment) => {
    updateSelectedAppointment(appointment)
    nextScreen(appointment)
  }

  const editNote = (note: AppointmentNote, appointment: Appointment) => {
    startEdit(note, appointment)
  }

  const viewNote = (note: AppointmentNote, appointment: Appointment) => {
    updateSelectedNote(note)
    updateSelectedAppointment(appointment)
    setCurrentScreen('review')
  }

  useEffect(() => {
    resetValues()
  }, [])

  return (
    <div className="initial">
      <div className="appointment-notes-table-container">
        {appointments.map((appointment) => (
          <PostAppointmentNoteTableRow
            key={appointment.id}
            appointment={appointment}
            createNew={createNew}
            editNote={editNote}
            viewNote={viewNote}
          />
        ))}
      </div>
    </div>
  )
}

export default Initial
